import { render, staticRenderFns } from "./accountmanagement.vue?vue&type=template&id=38c74844&scoped=true&"
import script from "./accountmanagement.vue?vue&type=script&lang=js&"
export * from "./accountmanagement.vue?vue&type=script&lang=js&"
import style0 from "./accountmanagement.vue?vue&type=style&index=0&id=38c74844&scoped=true&lang=scss&"
import style1 from "./accountmanagement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c74844",
  null
  
)

export default component.exports